import { primary2, white } from "@shane-collective/design-system";
import { Text, YStack, styled } from "tamagui";

export const Title = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$semibold",
  fontSize: "$sm",
  textAlign: "center",
  color: primary2,
  paddingTop: 10,
  paddingBottom: 10,
});

export const Container = styled(YStack, {
  backgroundColor: white,
  justifyContent: "center",
  borderRadius: 10,
  paddingRight: 10,
  gap: 15,
  display: "flex",
  flexDirection: "column",
  height: "100%",
});
